import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';

import { logger } from '../../utils/logger';

const contracts = fetcher.extend(() => ({ prefixUrl: `${API.CONTRACTS}` }));

export const deletePricing = async (key: string, { signal }: { signal?: AbortController['signal'] } = {}) => {
  try {
    return await contracts.delete(`contract-pricing/${key}`, { signal }).json();
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
